import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL 
});
console.log(" ~ baseURL:", process.env.REACT_APP_API_URL)

axiosInstance.interceptors.request.use(
  (config) => {
    // Get user email from localStorage
    const userEmail = localStorage.getItem('userEmail');
    
    // Add user_id as query parameter if email exists and not already in URL
    if (userEmail && !config.url.includes('user_id=')) {
      const separator = config.url.includes('?') ? '&' : '?';
      config.url = `${config.url}${separator}user_id=${encodeURIComponent(userEmail)}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle errors but don't redirect to login
    if (error.response?.status === 401) {
      console.error('Unauthorized request:', error.response?.data);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
